import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Cookies from 'js-cookie';
import Big from 'big.js';
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    } // todo 支持英文
    return value.toString().padStart(2, '0');
  });
  return time_str;
}
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}
export function addTableIndex(data, currentPage, pageSize) {
  var base = (currentPage - 1) * pageSize + 1;
  return data.map(function (item, i) {
    return _objectSpread(_objectSpread({}, item), {}, {
      tableIndex: base + i
    });
  });
}
export function readFileUrl(file) {
  return new Promise(function (reslove, reject) {
    var reader = new FileReader();
    reader.onload = function (e) {
      reslove(e.target.result);
    };
    reader.onerror = function (e) {
      reject(e);
    };
    reader.readAsDataURL(file);
  });
}
export function setCookie() {
  return Cookies.set.apply(Cookies, arguments);
}
export function getFixed(val, precision) {
  return Number(Big(val).toFixed(precision));
}
export function getNumber2Percent(num) {
  return Number(Big(num).times(100));
}
export function isNumber(val) {
  return typeof val === 'number' && !isNaN(val);
}
export function formatLongStr(val) {
  var mid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '...';
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;
  if (val.length > start + end) {
    return "".concat(val.substr(0, start)).concat(mid).concat(val.substr(val.length - end, end));
  }
  return val;
}
export function number2Percent(number) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var num = Number(number);
  if (!isNumber(num)) {
    return NaN;
  }
  return Number(Big(num).times(100).toFixed(precision));
}